import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "src/environments/environment";
import type {CurrentLegalVersionsView} from "../interfaces/current-legal-versions.interface";

@Injectable({
  providedIn: "root",
})
export class LegalService {
  private readonly apiDomain: string = environment.apiDomain;

  constructor(private readonly http: HttpClient) {}

  public getCurrentVersions(): Observable<CurrentLegalVersionsView> {
    return this.http.get<CurrentLegalVersionsView>(
      `${this.apiDomain}/legal/current-versions`
    );
  }
}
